// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getHasConnectedUsers } from '../../../../utils/collaboration/remoteUsersSelector';

// Components
import Tab from '../../../../components/tabs/Tab';
import Tabs from '../../../../components/tabs/Tabs';
import PoiBoardSectionContext from '../../../../components/pointsOfInterest/PoiBoardSectionContext';
import TrashPopupTabSwitch from './tab/TrashPopupTabSwitch';
import TrashEmptyFooter from './TrashEmptyFooter';

// Constants
import { BoardSections } from '../../../../../common/boards/boardConstants';
import { TRASH_TABS } from '../store/trashConstants';

// Styles
import './TrashPopupContent.scss';

const mapStateToProps = createStructuredSelector({
    hasConnectedUsers: getHasConnectedUsers,
});

const TrashPopupContent = (props) => {
    const { hasConnectedUsers, connectDropTarget } = props;

    // If a user isn't connected to any users, don't show the deleted by others tabs
    const tabs = hasConnectedUsers
        ? [<Tab tabId={TRASH_TABS.PERSONAL}>Deleted by me</Tab>, <Tab tabId={TRASH_TABS.OTHERS}>Deleted by others</Tab>]
        : [];

    return (
        <div ref={connectDropTarget}>
            <PoiBoardSectionContext.Provider value={BoardSections.TRASH}>
                <Tabs
                    className="TrashPopupContent"
                    initialActiveTab={TRASH_TABS.PERSONAL}
                    tabs={tabs}
                    footer={(activeTab) => <TrashEmptyFooter activeTab={activeTab} />}
                >
                    {(activeTab) => <TrashPopupTabSwitch activeTab={activeTab} {...props} />}
                </Tabs>
            </PoiBoardSectionContext.Provider>
        </div>
    );
};

TrashPopupContent.propTypes = {
    hasConnectedUsers: PropTypes.bool,
    connectDropTarget: PropTypes.func,
};

export default connect(mapStateToProps)(TrashPopupContent);
